let _apiurl = process.env.VUE_APP_APIURL;
let _appurl = process.env.VUE_APP_APPURL;
let _mode = process.env.VUE_APP_MODE;


export let apiurl = _apiurl;
export let appurl = _appurl;
export let mode = _mode;